module.exports = __webpack_public_path__ + "media/images/pic/teachers/hiroko-fujii-88213947dba0df81fe5403d3ecb54c71.webp";